import React from 'react';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { Field } from '../../../headless/field';

interface RequiredFileUploadProps {
  children?: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

export const Required = React.forwardRef<
  HTMLDivElement,
  RequiredFileUploadProps
>((props, ref) => {
  const { required } = useFieldProps<PublicFileUploadProps>();

  return <Field.Label.Required ref={ref} {...props} required={required} />;
});

Required.displayName = 'FileUpload.Label.Required';
